import _isString from 'lodash/isString'
import _isObject from 'lodash/isObject'
import _isUndefined from 'lodash/isUndefined'
import _filter from 'lodash/filter'
import _compact from 'lodash/compact'
import _omitBy from 'lodash/omitBy'

const handleParams = (...args) => {
  const options = _filter(args, _isObject)[0] || {}
  const { title: titleFromOption, desc: descFromOption, ...restOptions } = options

  const stringArgs = _filter(args, _isString)
  const desc = stringArgs.pop() || descFromOption
  const title = stringArgs.pop() || titleFromOption

  return _omitBy({ title, desc, ...restOptions }, _isUndefined)
}

const install = (Vue, _opts) => {
  Vue.prototype.$confirm = function () {
    const {
      title,
      desc,
      onOk,
      onCancel,
      onBackdrop,
      onError,
      dataCy,
      ...msgBoxOptions
    } = handleParams(...arguments)
    const themeClass = `tripla-theme ${this.$themeClassName}`
    const descLines = desc && (Array.isArray(desc) ? desc : [desc])

    const h = this.$createElement
    const children = _compact([
      title && h('h5', { class: ['font-weight-bold', 'text-left', 'mb-3'] }, [title]),
      descLines && descLines.map((description) => h('p', { class: ['text-left'] }, [description]))
    ])
    const confirmVNode = h(
      'div',
      { class: ['text-center'], attrs: { 'data-cy': dataCy } },
      children
    )

    // modal
    return this.$bvModal
      .msgBoxConfirm([confirmVNode], {
        okTitle: this.$t('base.confirm'),
        cancelTitle: this.$t('base.cancel'),
        okVariant: 't-theme',
        cancelVariant: 't-theme-outline',
        lazy: true,
        centered: true,
        ...msgBoxOptions,
        modalClass: [themeClass].concat(msgBoxOptions.modalClass)
      })
      .then((res) => {
        // callbacks for non-promise situation
        if (res === true) {
          onOk && onOk()
        }
        if (res === false) {
          onCancel && onCancel()
        }
        if (res === null) {
          onBackdrop && onBackdrop()
          onCancel && onCancel()
        }
        return res
      })
      .catch((e) => {
        if (onError) {
          return onError(e)
        }
        throw e
      })
  }

  Vue.prototype.$confirmLeave = function (...args) {
    return this.$confirm({
      title: this.$t('base.sureToLeave'),
      desc: this.$t('base.sureToLeaveDesc'),
      okTitle: this.$t('base.leave'),
      cancelTitle: this.$t('base.cancel'),
      okVariant: 'theme t-theme-btn maxw-3',
      cancelVariant: 'theme t-theme-btn-outline maxw-3',
      ...handleParams(...args)
    })
  }
}
export default { install }
